import * as React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { Store } from "redux";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import moment from "moment";
import "moment/locale/zh-cn";
import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";

import { Vh500, Vh404 } from "msd";
import MsLayout from "./components/ms-layout/MsLayout";
import MsTransit from "components/ms-layout/MsTransit";

import { HOME_PAGE } from "common/constants";
import { History } from "history";
import { ApplicationState } from "./store";
import "./App.scss";

// moment中文设置
moment.locale("zh-cn");

// 组件props声明
interface AppProps {
  store: Store<ApplicationState>
  history: History
}

// 异常页面定义
const noPage = () => <Vh404 homePage={ HOME_PAGE } />;
const noService = () => <Vh500 homePage={ HOME_PAGE } />;

/**
 * 根组件
 * 1、使用Provider提供redux state
 * 2、ConnectedRouter连接redux和router
 * 3、LocaleProvider提供antd中文设置
 * 4、加载Home组件
 *
 * @class App
 * @extends {React.Component<AppProps>}
 */
class App extends React.Component<AppProps> {
  // 渲染
  public render() {
    // 从props中获取store和history
    const { store, history } = this.props;

    // antd全局设置
    const config = {
      prefixCls: "msant",
      // 按钮文字中间空格去掉
      autoInsertSpaceInButton: false,
      // 空状态设置
      renderEmpty: () => (
        <div style={ {textAlign: "center"} }>
          <img alt="无图片" src={ `${ window.location.origin }/images/no-data.png` } style={ {width: 160, marginBottom: 36} } />
          <p>暂无数据</p>
        </div>
      ),
      // 国际化
      locale: zhCN
    };

    return (
      <Provider store={store}>
        <ConnectedRouter history={ history }>
          <ConfigProvider { ...config }>
            <Switch>
              <Route path="/404" exact={ true } component={ noPage } />
              <Route path="/500" exact={ true } component={ noService } />
              <Route path="/transit" exact={ true } component={ MsTransit } />
              <Route path="/" component={ MsLayout } />
              <Redirect to="/" />
            </Switch>
          </ConfigProvider>
        </ConnectedRouter>
      </Provider>
    );
  }
}

export default App;
